import {
  RecallAwbDirectionInterface,
  RecallAwbInterface,
  RecallClientActionsDataInterface,
} from "../../../../redux/interfaces/recall.interface";

export const canGenerateRecallDocument = (
  client: RecallClientActionsDataInterface,
) =>
  !client.document &&
  (!client.notice ||
    client.notice.status === "registered" ||
    client.notice.status === "received");

export const canRequestRecallAwb = (
  client: RecallClientActionsDataInterface,
  attemptedClientIds: number[],
) =>
  Boolean(client.document) &&
  client.notice?.status === "registered" &&
  !client.notice.receivedAt &&
  (!client.awb || client.awb.returnAwb === null) &&
  !attemptedClientIds.includes(client.clientPlId);

export const isRecallAwbSent = (awb?: RecallAwbDirectionInterface | null) =>
  awb?.status === "sent" && awb.awbNumbers.length > 0;

export const getRecallAwbResultStatus = (
  awb: RecallAwbInterface,
): RecallAwbDirectionInterface["status"] => {
  if (isRecallAwbSent(awb) && isRecallAwbSent(awb.returnAwb)) return "sent";
  if (
    !awb.returnAwb ||
    awb.status === "unknown" ||
    awb.returnAwb.status === "unknown"
  ) {
    return "unknown";
  }
  return "pending";
};

export const getRecallAwbResultDetail = (awb: RecallAwbInterface) => {
  const getDirectionLabel = (
    direction?: RecallAwbDirectionInterface | null,
  ) => {
    if (!direction) return "Nesolicitat";
    if (direction.awbNumbers.length) return direction.awbNumbers.join(", ");
    return direction.status === "pending" ? "In curs" : "Neconfirmat";
  };
  return `Plic: ${getDirectionLabel(awb)}; Retur: ${getDirectionLabel(
    awb.returnAwb,
  )}`;
};
